(function () {
  const STORAGE_KEY = "ls_selected_size";
  const PARAM_KEY = "ls_size";

  const SIZE_NAMES = ["size", "taille"]; // EN + FR

  function qs(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function setStoredSize(size) {
    try {
      sessionStorage.setItem(STORAGE_KEY, size);
    } catch (e) {}
  }

  function getStoredSize() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function normalize(s) {
    return (s || "").toString().trim().toLowerCase();
  }

  // Trouve les inputs de picker de variantes (radios / selects)
  function getAllVariantInputs() {
    return Array.from(
      document.querySelectorAll(
        'form[action*="/cart/add"] input[type="radio"], form[action*="/cart/add"] select'
      )
    );
  }

  // Essaye de détecter l'option "Taille/Size"
  function findSizeControls() {
    const inputs = getAllVariantInputs();

    const sizeRadios = inputs.filter((el) => {
      if (el.tagName.toLowerCase() !== "input") return false;

      // Plusieurs thèmes utilisent name="options[Taille]" ou name="options[Size]"
      const n = normalize(el.getAttribute("name"));
      if (SIZE_NAMES.some((k) => n.includes(`options[${k}`))) return true;

      // Certains thèmes mettent data-option-name
      const optName = normalize(el.getAttribute("data-option-name"));
      if (SIZE_NAMES.includes(optName)) return true;

      // Fallback: champ dans un fieldset dont le label contient "Taille/Size"
      const fieldset = el.closest("fieldset");
      if (fieldset) {
        const legend = normalize(fieldset.querySelector("legend")?.textContent);
        if (SIZE_NAMES.some((k) => legend.includes(k))) return true;
      }

      return false;
    });

    const sizeSelects = inputs.filter((el) => {
      if (el.tagName.toLowerCase() !== "select") return false;

      const n = normalize(el.getAttribute("name"));
      if (SIZE_NAMES.some((k) => n.includes(`options[${k}`))) return true;

      const optName = normalize(el.getAttribute("data-option-name"));
      if (SIZE_NAMES.includes(optName)) return true;

      const label = normalize(document.querySelector(`label[for="${el.id}"]`)?.textContent);
      if (SIZE_NAMES.some((k) => label.includes(k))) return true;

      return false;
    });

    return { sizeRadios, sizeSelects };
  }

  function readCurrentSelectedSize() {
    const { sizeRadios, sizeSelects } = findSizeControls();

    // Radios
    const checked = sizeRadios.find((r) => r.checked);
    if (checked && checked.value) return checked.value;

    // Select
    const sel = sizeSelects[0];
    if (sel && sel.value) return sel.value;

    return null;
  }

  function selectSizeIfPossible(sizeValue) {
    if (!sizeValue) return false;

    const desired = normalize(sizeValue);
    const { sizeRadios, sizeSelects } = findSizeControls();

    // Radios: clique le bon
    const radio = sizeRadios.find((r) => normalize(r.value) === desired);
    if (radio) {
      if (!radio.checked) {
        radio.click(); // déclenche les events du thème
      }
      return true;
    }

    // Select: set + dispatch change
    const sel = sizeSelects[0];
    if (sel) {
      const option = Array.from(sel.options).find((o) => normalize(o.value) === desired || normalize(o.textContent) === desired);
      if (option) {
        sel.value = option.value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
        return true;
      }
    }

    return false;
  }

  function attachSizeListeners() {
    // Dès qu'un utilisateur change une option, on mémorise la taille
    document.addEventListener("change", function () {
      const size = readCurrentSelectedSize();
      if (size) setStoredSize(size);
    });

    // Au clic sur une swatch "produit lié", on injecte la taille dans l'URL
    document.addEventListener("click", function (e) {
      const a = e.target.closest("a.ls-color-family__item");
      if (!a) return;

      const size = readCurrentSelectedSize() || getStoredSize();
      if (!size) return;

      try {
        const url = new URL(a.href, window.location.origin);
        url.searchParams.set(PARAM_KEY, size);
        a.href = url.toString();
      } catch (err) {}
    });
  }

  function applySizeFromUrlOrStorage() {
    const fromUrl = qs(PARAM_KEY);
    const stored = getStoredSize();
    const desired = fromUrl || stored;

    if (!desired) return;

    // Petit délai pour laisser le thème monter le variant picker
    window.setTimeout(() => {
      const ok = selectSizeIfPossible(desired);
      if (ok && fromUrl) {
        // Nettoie l'URL (optionnel)
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete(PARAM_KEY);
          window.history.replaceState({}, "", url.toString());
        } catch (e) {}
      }
    }, 250);
  }

  document.addEventListener("DOMContentLoaded", function () {
    attachSizeListeners();
    applySizeFromUrlOrStorage();
  });
})();